export default __webpack_public_path__ + "static/media/onboarding_1.d245a4bf.png";